const toggleSingle = (expanded, id) => (expanded?.[id] ? !expanded[id] : true);

const toggleExpand = ({ allowMultiple, expanded, id, itemIds }) => {
  // Add null checks for expanded and itemIds
  const safeExpanded = expanded || {};
  const safeItemIds = itemIds || [];

  if (!allowMultiple) {
    return safeItemIds.reduce((acc, itemId) => {
      const result =
        itemId === id
          ? { [id]: toggleSingle(safeExpanded, id) }
          : { [itemId]: false };
      return { ...acc, ...result };
    }, {});
  }
  return { ...safeExpanded, [id]: !safeExpanded[id] };
};

export default toggleExpand;
